import React from "react";
import {
  getShorthandName,
  getCountryByCode,
} from "../../../../../utils/Helper";

export const OwnershipProfileItem = ({ profile, designation }) => {
  return (
    <div style={{ "paddingBottom": "0px" }}
      className={`rounded-xl border p-6 sm:w-1/3 w-full ${designation === "individual" ? "border-CEO" : "border-CFO"
        }`}
    >
      <div className="flex flex-col sm:flex-row justify-center text-[10px] sm:text-f14 text-secondary ">
        <div className="flex flex-row  items-start text-left gap-2 mb-6">
            <div className=" w-14 h-14 rounded-full flex items-center justify-center border border-lightGray shadow-md">
              <span
                className={`text-profile ${getShorthandName(profile?.name || profile?.company_name || "")
                  .length > 2
                  ? "text-f12"
                  : "text-f14"
                  }`}
              >
                {getShorthandName(profile?.name || profile?.company_name || "")}
              </span>
            </div>
          <p className="capitalize">
            {profile?.ownershipCompany != '' && profile?.ownershipCompany != null ?
              <h5 className="text-f16 text-primary redirectsearch" onClick={() => {
                const url = `/search/${profile?.ownershipCompany}`;
                window.open(url, "_blank");
              }}>
                {profile?.name || profile?.company_name}
              </h5> : <h5 className="text-f16 text-primary">
                {profile?.name || profile?.company_name}
              </h5>}

            <span className="text-[14px]">
              {profile?.type} ({profile?.percentage_of_shares_held}%)
            </span>
          </p>
        </div>
      </div>
      <hr />
      <div className="flex flex-col gap-4 mt-4">
        {true && (
          <div className="flex justify-between text-f12 text-secondary text-left">
            <p>
              <span>Nationality</span>
              <h5 className="text-f14 text-primary">
                {getCountryByCode(profile?.nationality)}
              </h5>
            </p>
          </div>
        )}
        {true && (
          <div className="flex justify-between items-center text-f14 text-secondary text-left">
          </div>
        )}
        {true && (
          <div className="flex justify-between items-center text-f14 text-secondary text-left">
          </div>
        )}
      </div>
    </div>
  );
};
